import { Swiper, SwiperSlide } from 'swiper/react';
import classNames from 'classnames';
import { Button } from './Button';
import IconDiv from './IconDiv';
import faArrowLeft from '../img/icons/left.svg';
import {
  checkIfHighlightedDateIsSecondToLast,
  getNewHighlightedDate,
  newChangeDates,
  parseDay,
} from '../helpers/menuHelpers';
import faArrowRight from '../img/icons/right.svg';
import { customNumSort } from '../utils';
import MenuUnavailable from './MenuUnavailable';
import React, { useState } from 'react';

const Carousel = ({
  dates,
  fetchMenu,
  highlightedDate,
  isWide,
  menus,
  path,
  setDates,
  setHighLightedDate,
}) => {
  const [swiperMenu, setSwiperMenu] = useState(null);

  const handleSelectPreviewDate = () => {
    if (!checkIfHighlightedDateIsSecondToLast(highlightedDate, dates)) {
      swiperMenu.updateSlides();
      swiperMenu.slidePrev();
      return setHighLightedDate(getNewHighlightedDate(highlightedDate, 'down'));
    }
    return null;
  };

  const handleSelectNextDate = () => {
    swiperMenu.updateSlides();
    fetchMenu();
    setDates(newChangeDates('up', dates));
    setHighLightedDate(getNewHighlightedDate(highlightedDate, 'up'));
    swiperMenu.slideNext();
  };

  return (
    <div className="menu-widget-catering-menu__calendar">
      <Swiper
        allowTouchMove={false}
        centeredSlides={true}
        containerModifierClass={'swiper-for-dietly-'}
        initialSlide={7}
        observeparents="true"
        observer="true"
        observeslidechildren="true"
        onSwiper={setSwiperMenu}
        spaceBetween={0.1}
        slidesPerView={isWide ? 3 : 1}
      >
        {dates?.map((date, index) => {
          return (
            <SwiperSlide
              key={index}
              className={classNames('menu-widget__swiper-slide', {
                singleSlide: !isWide,
                threeSlides: isWide,
                heightAuto: true,
              })}
            >
              {() => (
                <div
                  className={classNames(
                    'flex-1 menu-widget-catering-menu__box',
                    {
                      'menu-widget-catering-menu__box--gray':
                        date !== highlightedDate && isWide,
                      'menu-widget-catering-menu__box--margin':
                        date === highlightedDate && isWide,
                      'menu-widget-catering-menu__box--shadow':
                        date === highlightedDate,
                    }
                  )}
                  key={date}
                >
                  <div className="menu-widget-catering-menu__buttons">
                    <Button
                      colorClean
                      containerClass={classNames(
                        'menu-widget-catering-menu__buttons-button',
                        {
                          'visibility-hidden':
                            date !== highlightedDate && isWide,
                        }
                      )}
                      icon={
                        <IconDiv
                          classes={classNames('menu-widget-button__arrow', {
                            'menu-widget-button__arrow--mobile': !isWide,
                          })}
                          path={path}
                          url={faArrowLeft}
                        />
                      }
                      onClick={handleSelectPreviewDate}
                    />
                    <div className="menu-widget__swiper-container">
                      <div className="menu-widget__swiper-title">
                        <div>{parseDay('d.LL.yyyy', date)}</div>
                        <div className="menu-widget__swiper-title-day">
                          {parseDay('cccc', date)}
                        </div>
                      </div>
                    </div>
                    <Button
                      colorClean
                      containerClass={classNames(
                        'menu-widget-catering-menu__buttons-button',
                        {
                          'visibility-hidden':
                            date !== highlightedDate && isWide,
                        }
                      )}
                      icon={
                        <IconDiv
                          classes={classNames('menu-widget-button__arrow', {
                            'menu-widget-button__arrow--mobile': !isWide,
                          })}
                          path={path}
                          url={faArrowRight}
                        />
                      }
                      onClick={handleSelectNextDate}
                    />
                  </div>

                  {menus[date]?.length > 0 ? (
                    <div className="menu-widget-catering-menu__box-menu">
                      <span className="menu-widget__swiper-menu-title">
                        {parseDay('cccc', date)}, {parseDay('d.LL.yyyy', date)}
                      </span>
                      {customNumSort('priority')(menus[date])?.map(meal => {
                        return (
                          <div
                            className="menu-widget__swiper-menu-meal-container"
                            key={meal?.menuMealId}
                          >
                            <div className="menu-widget__swiper-menu-meal-name">
                              {meal?.mealName}:{' '}
                              <span className="menu-widget__swiper-menu-meal-menu-name">
                                {meal?.menuMealName}
                              </span>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <MenuUnavailable />
                  )}
                </div>
              )}
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default Carousel;
